import { useEffect } from 'react';
function useDispatchQuery(query, dispatch, type) {
    useEffect(() => {
        if (query.isSuccess) {
            dispatch({
                type,
                payload: query.data,
            });
        }
    }, [dispatch, query.data, query.isSuccess, type]);
    return query;
}
export default useDispatchQuery;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlRGlzcGF0Y2hRdWVyeS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3JlYWN0LXF1ZXJ5L3NyYy91c2VEaXNwYXRjaFF1ZXJ5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxTQUFTLEVBQUUsTUFBTSxPQUFPLENBQUM7QUFJbEMsU0FBUyxnQkFBZ0IsQ0FBVSxLQUFxQixFQUFFLFFBQTZCLEVBQUUsSUFBTztJQUM1RixTQUFTLENBQUMsR0FBRyxFQUFFO1FBQ1gsSUFBSSxLQUFLLENBQUMsU0FBUyxFQUFFLENBQUM7WUFDbEIsUUFBUSxDQUFDO2dCQUNMLElBQUk7Z0JBQ0osT0FBTyxFQUFFLEtBQUssQ0FBQyxJQUFJO2FBQ04sQ0FBQyxDQUFDO1FBQ3ZCLENBQUM7SUFDTCxDQUFDLEVBQUUsQ0FBQyxRQUFRLEVBQUUsS0FBSyxDQUFDLElBQUksRUFBRSxLQUFLLENBQUMsU0FBUyxFQUFFLElBQUksQ0FBQyxDQUFDLENBQUM7SUFDbEQsT0FBTyxLQUFLLENBQUM7QUFDakIsQ0FBQztBQUVELGVBQWUsZ0JBQWdCLENBQUMifQ==